// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";
import Iconify from "../../../components/iconify";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: icon("dash"),
  business: icon("Business"),
  invoice: icon("Partner"),
  transaction: icon("transactions"),
  billing: icon("Bills"),
  fee: icon("Bills"),
  activity: icon("system"),
  bankLogs: icon("Bank"),
  sales: icon("sales"),
  affiliate: icon("Partner"),
  adminControl: icon("Controls"),
  ticketManagement: icon("Support"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "Overview",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.dashboard,
        icon: ICONS.dashboard,
      },
    ],
  },
  {
    subheader: "User Manager",
    items: [
      {
        title: "Business Management",
        path: PATH_DASHBOARD["business-management"].root,
        icon: ICONS.business,
        children: [
          {
            title: "All Busineses",
            path: PATH_DASHBOARD["business-management"].business.root,
          },
          {
            title: "Onboarding Requests",
            path: PATH_DASHBOARD["business-management"].requests.root,
          },
          {
            title: "Business Connections",
            path: PATH_DASHBOARD["business-management"].connections,
          },
        ],
      },
      {
        title: "Sales",
        path: PATH_DASHBOARD.sales.root,
        icon: ICONS.sales,
        children: [
          {
            title: "Dashboard",
            path: PATH_DASHBOARD.sales.dashboard,
          },
          {
            title: "Sales Users",
            path: PATH_DASHBOARD.sales.users,
          },
          {
            title: "Incentive Plan",
            path: PATH_DASHBOARD.sales.incentivePlan,
          },
          {
            title: "Settlement",
            path: PATH_DASHBOARD.sales.settlement,
          },
        ],
      },
      {
        title: "Affiliate",
        path: PATH_DASHBOARD.affiliate.root,
        icon: ICONS.affiliate,
        children: [
          {
            title: "Dashboard",
            path: PATH_DASHBOARD.affiliate.AffiliateAnalytics,
          },
          { title: "All Affiliates", path: PATH_DASHBOARD.affiliate.list },
          { title: "Tier Management", path: PATH_DASHBOARD.affiliate.tier },
          { title: "Settlement", path: PATH_DASHBOARD.affiliate.Settlement },
        ],
      },
    ],
  },
  {
    subheader: "Finance",
    items: [
      {
        title: "Invoice Requests",
        path: PATH_DASHBOARD.invoices,
        icon: ICONS.invoice,
      },
      {
        title: "Transactions",
        path: PATH_DASHBOARD.accounting,
        icon: ICONS.transaction,
      },
      {
        title: "Billing",
        path: PATH_DASHBOARD.billing,
        icon: ICONS.billing,
      },
      {
        title: "AssuredPay Fee",
        path: PATH_DASHBOARD.fee,
        icon: ICONS.fee,
      },
    ],
  },
  {
    subheader: "Logs",
    items: [
      {
        title: "Activity",
        path: PATH_DASHBOARD.activity,
        icon: ICONS.activity,
      },
      {
        title: "Bank Logs",
        path: PATH_DASHBOARD.BankLogs,
        icon: ICONS.bankLogs,
      },
    ],
  },
  {
    subheader: "Support",
    items: [
      {
        title: "Admin Control",
        path: PATH_DASHBOARD.AdminControl,
        icon: ICONS.adminControl,
      },
      {
        title: "Ticket management",
        path: PATH_DASHBOARD.TicketManagement.root,
        icon: ICONS.ticketManagement,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: "management",
  //   items: [
  //     {
  //       title: "user",
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: "Four", path: PATH_DASHBOARD.user.four },
  //         { title: "Five", path: PATH_DASHBOARD.user.five },
  //         { title: "Six", path: PATH_DASHBOARD.user.six },
  //       ],
  //     },
  //   ],
  // },
];

export default navConfig;
